import { Divider } from "@chakra-ui/react";
import "./App.css";
import {
  Navbar,
  Header,
  Footer,
  Main,
  About,
  Contacts,
  ScrollToTop,
  LoadingScreen,
  MissionStatement,
} from "./components";
import React, { useCallback, useEffect, useState } from "react";
import DotField from "./components/UX/DotField";
import { AnimatePresence } from "framer-motion";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleLoadingComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShowScrollTop(window.scrollY > 300);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {isLoading && <LoadingScreen onLoadingComplete={handleLoadingComplete} />}

      <div
        className="main-page"
        style={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in-out",
        }}
      >
        <DotField
          dotRadius={4}
          dotSpacing={30}
          cursorRadius={500}
          cursorForce={0.05}
          bulgeStrength={67}
          bulgeOnly={false}
          glowRadius={60}
          gradientFrom="#2e2e2e"
          gradientTo="#23133f"
          glowColor="#0b0b0b"
        />

        <AnimatePresence>{showScrollTop && <ScrollToTop />}</AnimatePresence>
        <Navbar />
        <header>
          <Header />
        </header>

        <main className="padding-main">
          <Divider />
          <Main />
          <About />
          <MissionStatement className="no-padding-section" />
          <Contacts />
        </main>

        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
}

export default App;